import { createMonitoringAPICall } from "../../Components/utils/createMonitoringAPICall";
import { AxiosResponse, AxiosError } from "axios";
import { AlertsApiResponse, GetAlertsParams } from "../../types/alertTypes"; // Import interfaces
import { logger } from "../../utils/logger";

const AxiosUI = createMonitoringAPICall(``); // Instance can be created here or passed in

// Track in-flight requests to prevent duplicate API calls
const pendingRequests: Map<string, Promise<AlertsApiResponse>> = new Map();

export const alertService = {
  getAlerts: async (params: GetAlertsParams): Promise<AlertsApiResponse> => {
    const { filterType, searchParamsString } = params;
    const url = `alert/?window_filter=${filterType}${searchParamsString}`;

    // If there's already an identical request in flight, return that promise
    const existingRequest = pendingRequests.get(url);
    if (existingRequest) {
      logger.log(
        "[alertService] Deduplicating request, reusing in-flight call"
      );
      return existingRequest;
    }

    // The service method focuses *only* on making the call and returning data or throwing an error
    const request = (async () => {
      try {
        const response: AxiosResponse<AlertsApiResponse> = await AxiosUI.get(
          url
        );
        return response.data; // Return only the data part of the response
      } catch (error) {
        // Re-throw the error to be handled by the caller (or perform minimal logging)
        logger.error("Error fetching alerts:", error);
        throw error; // Let the calling function handle UI logic/error state
      } finally {
        // Clear the pending request when done (success or failure)
        pendingRequests.delete(url);
      }
    })();

    pendingRequests.set(url, request);
    return request;
  },

  // Add other alert-related API calls here (e.g., getAlertById, updateAlert, etc.)
};
